<ul class="list-none p-0 m-0">
    <li class="flex align-items-center py-3 px-2 surface-border flex-wrap">
        <div class="text-500 w-full md:w-full font-medium">
            <p-checkbox [(ngModel)]="isAssignee" [binary]="true" label="Wnioskodawca reprezentowany przez pełnomocnika" (onChange)="hasAssigneeChanged($event.checked)"></p-checkbox>&nbsp;
            <i class="pi pi-info-circle" pTooltip="Zaznacz checkbox jeśli wypełniasz jako pełnomocnik wnioskodawcy" aria-hidden="true"></i>
            <br/><br/>
        </div>
    </li>
    <form #assigneeForm="ngForm" *ngIf="isAssignee">
        <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
            <div class="text-500 w-full md:w-3 font-medium">Imię/imiona*</div>
            <div class="text-900 w-full md:w-6 md:flex-order-0 flex-order-1">
                <input type="text" pInputText [ngModel]="proxy.firstname" (ngModelChange)="proxy.firstname=$event; proxyChange.emit(proxy)" #name="ngModel" name="name" required minlength="2"/>
                <small *ngIf="name.invalid && (name.dirty ||name.touched)" class="p-error block">
                    <div *ngIf="name?.errors?.['required']">
                        Imię jest wymagane.
                    </div>
                    <div *ngIf="name.errors?.['minlength']">
                        Imię musi mieć co najmniej 2 znaki.
                    </div>
                </small>
            </div>
        </li>
        <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
            <div class="text-500 w-full md:w-3 font-medium">Nazwisko*</div>
            <div class="text-900 w-full md:w-6 md:flex-order-0 flex-order-1">
                <input type="text" pInputText [ngModel]="proxy.surname" (ngModelChange)="proxy.surname=$event; proxyChange.emit(proxy)" #surname="ngModel" name="surname" required minlength="2"/>
                <small *ngIf="surname?.invalid && (surname.dirty || surname.touched)" class="p-error">
                    <div *ngIf="surname?.errors?.['required']">
                        Nazwisko jest wymagane.
                    </div>
                    <div *ngIf="surname?.errors?.['minlength']">
                        Nazwisko musi mieć co najmniej 2 znaki.
                    </div>
                </small>
            </div>
        </li>
        <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
            <div class="text-500 w-full md:w-3 font-medium">Adres do doręczeń*</div>
            <div class="text-900 w-full md:w-6 md:flex-order-0 flex-order-1">
                <input type="text" pInputText [ngModel]="proxy.address" (ngModelChange)="proxy.address=$event; proxyChange.emit(proxy)" #address="ngModel" name="address" required/>
                <small *ngIf="address?.invalid && (address.dirty || address.touched)" class="p-error">
                    <div *ngIf="address?.errors?.['required']">
                        Adres jest wymagany.
                    </div>
                </small>
            </div>
        </li>
        <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
            <div class="text-500 w-full md:w-3 font-medium">Pełnomocnictwo [PDF]*
                <i class="pi pi-info-circle" pTooltip="Pełnomocnictwo opatrzone podpisem elektronicznym, ustanowione do występowania przed KNF w sprawie wniosku o wpis pośrednika kredytowego do rejestru pośredników kredytowych." aria-hidden="true"></i>
            </div>
            <div class="text-900 w-full md:w-6 md:flex-order-0 flex-order-1">
                <p-fileUpload #af mode="advanced" accept="application/pdf"
                              [ngClass]="{'p-error' : assigneeFormDirty && !authFile}"
                              [customUpload]="true" [auto]="true"
                              (uploadHandler)="uploadHandler($event, af, AttachmentType.AUTHORIZATION)"
                              (onRemove)="fileRemove(AttachmentType.AUTHORIZATION, af)"
                              chooseLabel="Dodaj plik"
                              [maxFileSize]=10000000 required name="authFile"
                              invalidFileTypeMessageSummary="{0}: Niepoprawny typ pliku"
                              invalidFileTypeMessageDetail="dopuszczalny typ: pdf"
                              invalidFileSizeMessageSummary="{0}: Przekroczony rozmiar pliku"
                              invalidFileSizeMessageDetail="maksymalny rozmiar pliku: {0}">
                </p-fileUpload>
                <small *ngIf="assigneeFormDirty && !authFile" class="p-error">
                    Brak pliku z pełnomocnictwem
                </small>
            </div>
        </li>
        <li class="flex align-items-center py-3 px-2 border-top-1 surface-border flex-wrap">
            <div class="text-500 w-full md:w-3 font-medium">Opłata za pełnomocnictwo [PDF]*
                <i class="pi pi-info-circle" pTooltip="Potwierdzenie uiszczenia opłaty skarbowej od pełnomocnictwa w wysokości 17 zł, o której mowa w ustawie z dnia 16 listopada 2006 r. o opłacie skarbowej, na rachunek Urzędu Miasta Stołecznego Warszawy, nr rachunku: 21 1030 1508 0000 0005 5000 0070." aria-hidden="true"></i>
            </div>
            <div class="text-900 w-full md:w-6 md:flex-order-0 flex-order-1">
                <p-fileUpload #authPayFile mode="advanced" accept="application/pdf"
                              [ngClass]="{'p-error' : assigneeFormDirty && !authPaymentFile}"
                              [customUpload]="true" [auto]="true"
                              (uploadHandler)="uploadHandler($event, authPayFile, AttachmentType.AUTH_PAYMENT)"
                              (onRemove)="fileRemove(AttachmentType.AUTH_PAYMENT, authPayFile)"
                              chooseLabel="Dodaj plik"
                              [maxFileSize]=10000000
                              invalidFileTypeMessageSummary="{0}: Niepoprawny typ pliku"
                              invalidFileTypeMessageDetail="dopuszczalny typ: pdf"
                              invalidFileSizeMessageSummary="{0}: Przekroczony rozmiar pliku"
                              invalidFileSizeMessageDetail="maksymalny rozmiar pliku: {0}">
                </p-fileUpload>
                <small *ngIf="assigneeFormDirty && !authPaymentFile" class="p-error">
                    Brak pliku z opłatą za pełnomocnictwo
                </small>
            </div>
        </li>
    </form>
</ul>
